import SEOHead from '@/components/feature/SEOHead';
import HomeHero, { HomeFeatured } from './components/HomeHero';
import HomeCategories from './components/HomeCategories';
import HomeArticles from './components/HomeArticles';
import HomeFAQ from './components/HomeFAQ';
import Newsletter from './components/Newsletter';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '拍得好',
  url: 'https://ixhzs.cn',
  description: '自拍与抓拍技巧分享平台，致力于帮助每一位摄影爱好者拍出自然真实、充满情感的人像作品。',
  foundingDate: '2024',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'hello@ixhzs.cn',
    contactType: 'customer service',
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '拍得好',
  url: 'https://ixhzs.cn',
  description: '自拍偷拍技巧大全，掌握构图、设备、角度与后期处理方法，拍出自然感人的摄影作品。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://ixhzs.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="自拍偷拍技巧大全：拍出自然感人像的完整指南"
        description="想掌握自拍偷拍的精髓？拍得好汇集自拍偷拍的构图技巧、设备推荐、角度选择与后期处理方法，帮助摄影爱好者拍出自然真实、充满情感的人像作品，适合新手与进阶摄影师参考学习。"
        keywords="自拍偷拍,自拍偷拍技巧,街头抓拍教程,自然人像摄影,手机自拍构图,隐蔽拍摄角度,人文纪实摄影"
        canonicalUrl="/"
        ogImage="https://readdy.ai/api/search-image?query=Photography%20tutorial%20website%20hero%2C%20self-portrait%20and%20candid%20photography%2C%20warm%20cream%20tones%2C%20minimalist%20design%2C%20artistic%20camera%20and%20lens%20composition%2C%20editorial%20style&width=1200&height=630&seq=og-home&orientation=landscape"
        schema={{
          ...organizationSchema,
          ...websiteSchema,
          '@type': ['Organization', 'WebSite'],
        }}
      />

      <main>
        <article>
          <HomeHero />

          <section className="bg-background-50">
            <HomeFeatured />
          </section>

          <HomeCategories />
          <HomeArticles />
          <HomeFAQ />
          <Newsletter />
        </article>
      </main>
    </>
  );
}